import { IconButton } from '@/components/IconButton'
import styles from './DetailsHeader.module.css'

export interface DetailsHeaderProps {
  onClose: () => void
}

export function DetailsHeader({ onClose }: DetailsHeaderProps) {
  return (
    <div className={styles.root}>
      <IconButton
        name="back"
        label="Close details"
        onPress={onClose}
        size={24}
      />
    </div>
  )
}
